export const DEFAULT_ACTIVE_PRESET_ID = 'builtin-classic';

export const PRESET_STYLE_OPTIONS = [
  { value: 'classic-slide', label: 'Classic Slide' },
  { value: 'minimal-box', label: 'Minimal Boxes' },
  { value: 'modern-accent', label: 'Modern Accent' },
  { value: 'edge-link', label: 'Diagonal Edge' },
  { value: 'logo-badge', label: 'Logo Badge' },
];

const baseVisual = {
  colorPrimary: '#3b82f6',
  colorSecondary: '#1e293b',
  colorTextUpper: '#ffffff',
  colorTextLower: '#cbd5e1',
  scale: 1,
  rotation: 0,
  posX: 100,
  posY: 850,
  classicRadius: 10,
  classicAccentWidth: 15,
  classicTextPaddingX: 40,
  minimalNameHeight: 70,
  minimalTitleHeight: 50,
  minimalTextPaddingX: 20,
  modernSkewOffset: 50,
  modernAccentOffset: 30,
  modernAccentWidth: 20,
  modernTextX: 80,
  templateShapeVisible: true,
  templateMainTextVisible: true,
  templateSubTextVisible: true,
  shapePrimitives: [],
  layerOrder: [],
  layerLocks: {},
  updatedAt: 0,
};

export const DEFAULT_PRESETS = [
  {
    ...baseVisual,
    id: 'builtin-classic',
    name: 'Classic Slide',
    isBuiltIn: true,
    preset: 'classic-slide',
  },
  {
    ...baseVisual,
    id: 'builtin-minimal',
    name: 'Minimal Boxes',
    isBuiltIn: true,
    preset: 'minimal-box',
  },
  {
    ...baseVisual,
    id: 'builtin-modern',
    name: 'Modern Accent',
    isBuiltIn: true,
    preset: 'modern-accent',
  },
  {
    ...baseVisual,
    id: 'builtin-edge-link',
    name: 'Diagonal Edge',
    isBuiltIn: true,
    preset: 'edge-link',
    posX: 160,
    posY: 842,
    colorPrimary: baseVisual.colorPrimary,
    colorSecondary: baseVisual.colorSecondary,
    colorTextUpper: baseVisual.colorTextUpper,
    colorTextLower: baseVisual.colorTextLower,
  },
  {
    ...baseVisual,
    id: 'builtin-logo-badge',
    name: 'Logo Badge',
    isBuiltIn: true,
    preset: 'logo-badge',
    posX: 92,
    posY: 842,
    colorPrimary: baseVisual.colorPrimary,
    colorSecondary: baseVisual.colorSecondary,
    colorTextUpper: baseVisual.colorTextUpper,
    colorTextLower: baseVisual.colorTextLower,
  },
];
